import * as React from 'react';
import { ReactNode, useMemo } from 'react';
import Box from '@mui/material/Box';
import ReleaseNoteWrapper from './ReleaseNoteWrapper';
import { TabContext, TabPanel } from '@mui/lab';
import { Route, useNavigate, useParams } from 'react-router-dom';
import PageNotFound from 'Common/components/PageNotFound';
import { UpdateOutlined } from '@mui/icons-material';
import * as Paths from '@toolkit/router/paths';
import { TealTab, TealTabs } from 'Common/components/TealTabs';

export const RELEASE_NOTES: string[] = [
  'latest',
  '2024',
  '2023',
  '2022',
  '2021',
];

export default function Updates(): ReactNode {
  const params = useParams();
  const navigate = useNavigate();

  let year = params.year || RELEASE_NOTES[0];

  function handleChange(event: React.SyntheticEvent, newValue: string) {
    navigate(newValue);
  }

  if (!RELEASE_NOTES.includes(year)) {
    return (
      <PageNotFound
        page="Updates"
        path={Paths.Updates}
        icon={<UpdateOutlined />}
      />
    );
  }

  const releaseNotePanels = useMemo(() => {
    return RELEASE_NOTES.map((releaseNote) => (
      <TabPanel
        key={releaseNote}
        value={releaseNote}
        id={`release-note-${releaseNote}`}
      >
        <ReleaseNoteWrapper year={releaseNote} />
      </TabPanel>
    ));
  }, [RELEASE_NOTES]);

  return (
    <Box
      position={'relative'}
      sx={{
        width: '100% !important',
        '& #header': {
          m: 0,
          p: 0,
          pb: 1,
          maxWidth: '100%',
          zIndex: 1,
        },
        '& #content': {
          ml: '1px !important',
          p: 0,
          zIndex: 1,
        },
      }}
    >
      <TabContext value={year}>
        <TealTabs value={year} onChange={handleChange}>
          {RELEASE_NOTES.map((releaseNote) => {
            const label =
              releaseNote.substring(0, 1).toUpperCase() +
              releaseNote.substring(1).toLowerCase();
            return (
              <TealTab key={releaseNote} label={label} value={releaseNote} />
            );
          })}
        </TealTabs>
        {releaseNotePanels}
      </TabContext>
    </Box>
  );
}

export const UpdatesRoute = (
  <Route>
    <Route path=":year" element={<Updates />} />
  </Route>
);
